import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import CouponListingPageSidebar from "components/CouponListingPage/Sidebar";
import CouponList from "components/CouponList";
import CouponListingPageAction from "components/CouponListingPage/Actions";
import HotOffers from "components/HotOffers";
import {
  getHotOffersData,
  getCouponCategoriesDetails,
  getBannerAdsData,
} from "redux/actions";
import { getLocalStorageValue } from 'config/helper';

import "./coupons.scss";
import AdsSpaceSectionMainTheme2 from "routes/individual-departmentTheme2/AdsSpaceSectionMainTheme2";
import { useGetCouponList } from 'hooks/useGetCouponList';

const Coupon = () => {
  const dispatch = useDispatch();
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const breadcrumbList = [{ lable: "Coupon", link: "", searchTag: "" }];

  const {
    bannerAdsData,
    bannerAdsDataLoading
  } = useSelector(({ bannerAds }) => bannerAds);

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    dispatch(getHotOffersData(body));
  }, [storeId]); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    dispatch(getCouponCategoriesDetails(body));
  }, [storeId]); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      member_number: isUserLoggedIn ? memberNumber : "",
      category_ids: "",
      search: "",
      funtional_text: "",
      placement: "run-of-site-banner-x",
      ros:"Coupons"
    };
    dispatch(getBannerAdsData(body));
  }, []); // eslint-disable-line

  const hotOffersData = useSelector(({ hotOffers }) => hotOffers.hotOffersData);
  const hotOfferTitle = hotOffersData.title;
  const adverstiseSectionData = hotOffersData.adverstise_section;

  const { isLoading: couponListLoading } = useGetCouponList();
  const couponCategoriesData = useSelector(
    ({ coupon }) => coupon.couponCategoriesData
  );

  const checkViewportWidth = useCallback(() => {
    setIsMobile(window.innerWidth < 769);
  }, []);
    
  useEffect(() => {
    checkViewportWidth();
    window.addEventListener('resize', checkViewportWidth);
    return () => {
      window.removeEventListener('resize', checkViewportWidth);
    };
  }, [checkViewportWidth]);

  return (
    <>
      {!couponListLoading && couponCategoriesData?.length > 0 && (
        <>
          <BreadcrumbDetailed
            breadcrumbList={breadcrumbList}
            title={`Coupons`}
          />
          {!bannerAdsDataLoading && bannerAdsData && bannerAdsData.ads?.find(ad => ad.slotId === "Horizontal Banners")?.banners[0] && (
            <AdsSpaceSectionMainTheme2 isMobile={isMobile} adsDetails={bannerAdsData.ads?.find(ad => ad.slotId === "Horizontal Banners")?.banners[0]} />
          )}
          <div className="container">
            <div className="search-coupon-listing-page-wrapper">
              <div className="listing-page-wrapper-items">
                <CouponListingPageSidebar bannerAd={bannerAdsData?.ads?.find(ad => ad.slotId === "Vertical Banners")?.banners ?? []} />
              </div>
              <div className="listing-page-wrapper-items">
                {/* <AdsSpaceSection /> */}
                <CouponListingPageAction />
                <CouponList />
              </div>
            </div>
            <HotOffers
              title={hotOfferTitle}
              adverstiseSectionData={adverstiseSectionData}
            />
          </div>
        </>
      )}
    </>
  );
};
export default Coupon;
